// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-link[data-v-3cd0949e]{cursor:unset!important}.el-link.is-underline[data-v-3cd0949e]:hover:after{content:none}", ""]);
// Exports
module.exports = exports;
